import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../authContext';
import { LoadingSpinner } from '../../general/LoadingSpinner';

export const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  
  console.log('Protected route check:', { 
    path: location.pathname,
    isAuthenticated, 
    isLoading,
    hasToken: !!localStorage.getItem('authToken')
  });
  
  // Show loading indicator while checking auth status
  if (isLoading) {
    return <LoadingSpinner message="Loading..." />;
  }
  
  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    console.log('User not authenticated, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // Render child routes if authenticated
  console.log('User is authenticated, rendering protected content');
  return <Outlet />;
};